export const klageParteiCheckboxesZodDescription = "klageParteiCheckboxes";
